import { observer } from 'mobx-react-lite';
import { Button, Modal } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import { useEffect, useState } from 'react';
import VerifyDragDrop from '../../Dashboard/Receiving/VerifyImageUpload/VerifyDragDrop';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { v4 as uuid } from 'uuid';
import agent from '../../../app/api/agent';
import { uploadFileType } from '../../../app/api/types';
import {
  Communication,
  TemplateSubTasks,
  TemplateTask,
  WorkflowElement,
  WorkflowOptions,
  tempApi,
} from '../../../app/models/template';
import { TemplateSubTaskType } from '../../Settings/WorkflowSettings/autoRejectSetting/type';
import { FileUploadInterface } from '../../../app/models/Profile';
import ReelCreationDynamicTable from './ReelCreationDynamicTable';
const extractAndSortNumbers = (str:string) => {
  const numbers = removeBeforeFirstComma(str).split(",").map(Number);
  return numbers.sort((a, b) => a - b).join(",");
}
const removeBeforeFirstComma = (input:string) => {
  return input.startsWith(",") ? input.substring(1) : input;
};
const ReelsCreationNFAI = () => {
  const {
    mediaAssetStore: {
      mediaAsset: { openReelsCreation },
      setOpenReelsCreation,
    },
    userStore: { user },
    commonStore,
    activityStore: { selectedActivity: activity },
    dashboardStore: {
      dashboard,
      getLocalFilesBasedOnItem,
      updateCreateOrderTemplate,
    },
    ElementStore: { generatePdf },
    viewStore: {
      allowReelPDFuploadCheck,
      allowReelPDF,
      nfaiPDF2CSV,
      Pdf2CsvLoader,
      reelTemplateDetails,
      resetReelTemplateDetails,
      createReelItem,
      countUpdatePostReelCreation,
    },
    metaDataStore: { WorkflowMetadataHandler },
    TemplateStore: { loadTemplateIdForCR, selectedTemplate },
    clonedStore: {
      loadSectionMultipleById,
      loadSectionById,
      loadComponentById,
    },
    mediaAssetStore,
  } = useStore();

  const [files, setFiles] = useState<File[]>([]);
  const [uploadedFileRes, setUploadedFileRes] = useState<uploadFileType>();
  const [currentTaskDetails, setCurrentTaskDetails] = useState<{
    currentTask: string;
    currentSubTask: string;
    activeTaskCount: number;
  }>({
    currentTask: '',
    currentSubTask: '',
    activeTaskCount: 0,
  });
  const [reelCreateLoader,setReelCreateLoader] = useState(false);

  useEffect(() => {
    (async () => {
      await allowReelPDFuploadCheck({ itemId: activity?.id });
    })();
    // eslint-disable-next-line
  }, [activity?.id]);

  useEffect(() => {
    resetReelTemplateDetails();
    // eslint-disable-next-line
  }, []);

  const onDrop = (acceptedFiles: File[]) => {
    setFiles(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      ),
    );
  };

  useEffect(() => {
    if (reelTemplateDetails?.templateId) {
      loadTemplateIdForCR(reelTemplateDetails?.templateId);
    }
    // eslint-disable-next-line
  }, [reelTemplateDetails?.templateId]);

  useEffect(() => {
    if (selectedTemplate && selectedTemplate.tasks.length > 0) {
      if(user?.customerName === 'NFAIReport'){
      const activeTaskTemp = selectedTemplate?.tasks;
      const tempCurrentTaskData = [];
      const tempCurrentSubTaskData = [];
      let firstTask = '';
      let firstSubTask = '';
  
      for (let i = 0; i < activeTaskTemp?.length; i++) {
        const dep = activeTaskTemp[i].dependencyTask;
       const dependencyParts = typeof dep === 'string' ? dep.split('|') : [];
        const dependencyTask = dependencyParts[1] !== 'undefined' && dependencyParts[1] !== undefined ? dependencyParts[1]: '';
        if (activeTaskTemp[i].isActive === true) {
          if(i===0){
            activeTaskTemp[i].isParallel = true;
          }
           if (activeTaskTemp[i].isParallel === true && (dependencyTask=== '' )) {
            activeTaskTemp[i].isCurrentTask = true;
            tempCurrentTaskData.push(activeTaskTemp[i]?.taskName);
            const subtaskDetail = activeTaskTemp[i]?.subTasks;
            for (let j = 0; j < subtaskDetail?.length; j++) {
              if (subtaskDetail[j].isActive === true && j===0) {
                subtaskDetail[j].isCurrentSubtask = true;
                tempCurrentSubTaskData.push(subtaskDetail[j].subTaskName);
                break;
              }
            }
          }
        }
      }
      tempCurrentTaskData.unshift(firstTask);
      tempCurrentSubTaskData.unshift(firstSubTask);
  
      setCurrentTaskDetails({
        currentTask: tempCurrentTaskData.filter(Boolean).join(',') || 'NA',
        currentSubTask: tempCurrentSubTaskData.filter(Boolean).join(',') || 'NA',
        activeTaskCount: activeTaskTemp.length,
    });    
  
      updateCreateOrderTemplate(selectedTemplate);
    }else{
      const activeTaskTemp = selectedTemplate?.tasks?.filter(
        (t: TemplateTask) => t.isActive === true,
      );
      const activeSubTaskTemp = activeTaskTemp?.[0].subTasks?.filter(
        (st: TemplateSubTaskType | TemplateSubTasks) => st.isActive === true,
      );
      setCurrentTaskDetails({
        currentTask: activeTaskTemp?.[0].taskName || 'NA',
        currentSubTask: activeSubTaskTemp?.[0]?.subTaskName || 'NA',
        activeTaskCount: activeTaskTemp.length,
      });
      updateCreateOrderTemplate(selectedTemplate);
    }
    }
    // eslint-disable-next-line
  }, [selectedTemplate]);

  useEffect(() => {
    loadComponentById(activity?.id);
    loadSectionById(activity?.id + '/' + activity?.title);
    loadSectionMultipleById(activity?.id + '/' + activity?.title);
    // eslint-disable-next-line
  }, [mediaAssetStore.mediaAsset.refreshSectionMain]);

  const handleReelCreation = async () => {
    if(reelCreateLoader) return;
    setReelCreateLoader(true);
    reelTemplateDetails?.reels?.forEach(
      async (reel: {
        reelNo: string;
        startFrame: number;
        endFrame: number;
        totalFrame: number;
        totalDurationInMins: string;
      }) => {
        const generatedID = uuid();
        const generatedTitle = `${activity?.title} - Reels ~ ${extractAndSortNumbers(reel.reelNo)?.replace(/^0+/, '')?.replaceAll(',','+')}`;
        let tempMeta: any[] = [];
        await WorkflowMetadataHandler(reelTemplateDetails?.elementId).then(
          (Response) => {
            let eleVal;
            tempMeta = Response?.map((_data: any) => {
              switch (_data.elementName) {
                case 'Reel No':
                  eleVal = extractAndSortNumbers(reel.reelNo)?.replace(/^0+/, '')?.replaceAll(',','+');
                  break;
                case 'Start Frame':
                  eleVal = reel.startFrame;
                  break;
                case 'End Frame':
                  eleVal = reel.endFrame;
                  break;
                case 'Total  Frames':
                  eleVal = reel.totalFrame;
                  break;
                case 'Total  Duration  in Min':
                  eleVal = reel.totalDurationInMins;
                  break;
                default:
                  eleVal = '';
                  break;
              }
              return {
                ..._data,
                elementId: uuid(),
                elementValue: eleVal,
                options: _data.options?.map((opt: any) => {
                  return {
                    ...opt,
                    optionId: uuid(),
                  };
                }),
              };
            });
          },
        );
        const receivingWF = { ...dashboard.CreateOrderTemplate };
        if (receivingWF) {
          receivingWF.templateId = uuid();
          receivingWF.isActive = true;
          receivingWF.isDeleted = false;
          receivingWF.tasks?.forEach((task: any, index: number) => {
            task.taskId = uuid();
            if (index === 0 || task.isParallel) {
              task.isCurrentTask = true;
            } else {
              task.isCurrentTask = false;
            }
            task?.subTasks?.forEach((subtask: any, stIndex: number) => {
              subtask.subTaskId = uuid();
              if (task.isCurrentTask && stIndex === 0) {
                subtask.isCurrentSubtask = true;
              } else {
                subtask.isCurrentSubtask = false;
              }
              subtask?.communication?.forEach(
                (communication: Communication) => {
                  communication.id = uuid();
                },
              );
              subtask?.api?.forEach((tempApi: tempApi) => {
                tempApi.id = uuid();
              });
              subtask?.elements?.forEach((element: WorkflowElement) => {
                element.elementId = uuid();
                element?.options?.forEach((options: WorkflowOptions) => {
                  options.optionId = uuid();
                });
                element?.files?.forEach((File: FileUploadInterface) => {
                  File.id = uuid();
                });
                element?.photos?.forEach((photos: FileUploadInterface) => {
                  photos.id = uuid();
                });
              });
            });
          });
        }
        const generatedOrders = [
          {
            orderId: uuid(),
            orderDateTime: new Date().toISOString(),
            username: user?.displayName,
            customerId: user?.customerName,
            departmentId: reelTemplateDetails?.departmentId,
            templateId: reelTemplateDetails?.templateId,
            isActive: true,
            isDeleted: false,
            isReceiving: true,
            isDelivery: false,
            isReturn: false,
            itemOrderReceiving: [
              {
                id: uuid(),
                customerId: user?.customerName,
                departmentId: reelTemplateDetails?.departmentId,
                receivingId: '',
                isActive: true,
                isDeleted: false,
                receivingWorkflows: [receivingWF],
              },
            ],
          },
        ];
        const item = {
          id: generatedID,
          title: generatedTitle,
          departmentId: reelTemplateDetails?.departmentId,
          departmentName: reelTemplateDetails?.departmentName,
          typeid: reelTemplateDetails?.typeId,
          type: reelTemplateDetails?.typeName,
          elementtypeid: reelTemplateDetails?.elementId,
          element: reelTemplateDetails?.elementName,
          asset_tracking_status: 'Receiving Order Created',
          asset_In_Vault: activity?.asset_In_Vault,
          order_tracking: '',
          physical_sensor_barcode: generatedID,
          physical_sensor_RFID: generatedID,
          physical_sensor_qrcode: generatedID,
          physical_location_rack: activity?.physical_location_rack,
          physical_location_shelf: activity?.physical_location_shelf,
          physical_location_vault: activity?.physical_location_vault,
          global_positioning_system: activity?.global_positioning_system,
          parent: activity?.id + '/' + activity?.title,
          receivingdate: new Date().toISOString(),
          itemCreatedAt: new Date().toISOString(),
          last_modified: new Date().toISOString(),
          movementdate: new Date().toISOString(),
          maintenance: new Date().toISOString(),
          status_Time: new Date().toISOString(),
          assignedUsers: [
            {
              appUserId: user?.id,
              itemLevelId: generatedID,
              isHost: true,
            },
          ],
          itemHistory: [
            {
              id: uuid(),
              itemId: generatedID,
              appUserId: user?.id,
              username: user?.displayName,
              dateTime: new Date().toISOString(),
              url: user?.image,
              status: `User ${user?.displayName!} created "${generatedTitle}" through Reels Creation`,
            },
          ],
          isReceivingOrder: true,
          isReceiving: true,
          isDelivery: false,
          isDeleted: false,
          isActive: true,
          status: 'Yet to Start',
          current_task: currentTaskDetails.currentTask,
          current_subtask: currentTaskDetails.currentSubTask,
          current_user: user?.customerName,
          itemCreatedBy: user?.customerName,
          metadata: [...tempMeta],
          orders: generatedOrders || [],
        };
        await createReelItem(
          {
            itemGroupId: reelTemplateDetails?.itemGroupId,
            itemId: activity?.id,
          },
          item,
        );
      },
    );
    await countUpdatePostReelCreation({
      reelCount: reelTemplateDetails?.reels.length,
      taskCount: currentTaskDetails.activeTaskCount,
    });
    setReelCreateLoader(false);
    setOpenReelsCreation(!openReelsCreation);
    setTimeout(() => {
      mediaAssetStore.mediaAsset.refreshSectionMain =
        !mediaAssetStore.mediaAsset.refreshSectionMain;
    }, 3000);
  };

  const upload = async (e: any) => {
    e.preventDefault();
    let response;
    let addFilesPayload: uploadFileType = { id: '', files: [] };
    files.forEach(async (file) => {
      if (commonStore.devEnv) {
        const item = activity?.id;
        const workLevel =
          dashboard.dashboardWorkLevelMaster?.id || 'Reels Creation Reports';
        response = await agent.Files.localFileUpload(file, workLevel, item);
        const url = response.data.path.replace(/\\\\/g, '\\');
        const filename = url.substring(url.lastIndexOf('\\') + 1);
        addFilesPayload = {
          id: activity?.id,
          files: [
            {
              id: uuid(),
              fileId: response.data.id,
              fileName: filename,
              url: url,
              addedOn: new Date(),
            },
          ],
        };
        getLocalFilesBasedOnItem(item);
      } else {
        response = await agent.Files.uploadFile(file);
        addFilesPayload = {
          id: activity?.id,
          files: [{ ...response.data, addedOn: new Date() }],
        };
      }
      setUploadedFileRes(addFilesPayload);
      await generatePdf(addFilesPayload);
    });
    setTimeout(async () => {
      await allowReelPDFuploadCheck({ itemId: activity?.id });
    }, 400);
    resetReelTemplateDetails();
    setFiles([]);
  };

  const handleScanData = () => {
    nfaiPDF2CSV({
      ItemId: activity?.id,
      path: allowReelPDF,
    });
  };

  return (
    <Modal
      trigger={
        <Button
          style={{
            display: user?.customerName === 'NFAIReport' ? 'auto' : 'none',
            marginTop: '8px',
          }}
        >
          {' '}
          Upload PDF for Reels Creation
        </Button>
      }
      onClose={() => setOpenReelsCreation(!openReelsCreation)}
      onOpen={() => setOpenReelsCreation(!openReelsCreation)}
      open={openReelsCreation}
    >
      <Modal.Header>Reels Creation</Modal.Header>
      <Modal.Content style={reelTemplateDetails?.reels?.length > 0 ? { height: '85vh' } : {}}>
        <>
          {uploadedFileRes &&
            uploadedFileRes?.files.map((f: any) => {
              return (
                <>
                  {f.url.match(/\.(pdf)$/i) && (
                    <>
                      <img
                        src={'/assets/documents.jpg'}
                        alt={'uploaded doc'}
                        style={{
                          height: '70px',
                        }}
                      />
                      <p>{f.fileName}</p>
                    </>
                  )}
                </>
              );
            })}
        </>
        <VerifyDragDrop
          files={files}
          onDrop={onDrop}
          disableCheck={allowReelPDF !== ''}
        />
        <div>
          <Button
            onClick={(e) => upload(e)}
            positive
            disabled={allowReelPDF !== ''}
            style={{ width: '180px' }}
            //Upload
          >
            {
              (userLanguage[0].Level3InventoryRecievingVerify?.IRVB04 as any)?.[
                `${commonStore.language.key}`
              ]
            }
          </Button>
          {allowReelPDF && (
            <p style={{ margin: '8px 0' }}>
              *Picture_Scan PDF uploaded. Kindly proceed with further steps.
            </p>
          )}
        </div>
        {allowReelPDF && (
          <div>
            <Button
              color={'orange'}
              style={{ width: '180px', marginTop: '8px' }}
              onClick={handleScanData}
              disabled={Pdf2CsvLoader}
              loading={Pdf2CsvLoader}
            >
              Scan Data
            </Button>
            {reelTemplateDetails?.excelPath !== '' && (
              <p style={{ margin: '8px 0' }}>File Scanned Successfully !!!</p>
            )}
          </div>
        )}
        {reelTemplateDetails?.reels?.length > 0 && (
          <>
            <ReelCreationDynamicTable
              reels={(reelTemplateDetails?.reels as any[]) || []}
            />
            <Button
              color={'teal'}
              style={{ width: '180px', marginTop: '8px' }}
              onClick={handleReelCreation}
              loading={reelCreateLoader}
            >
              Create Reels
            </Button>
          </>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => setOpenReelsCreation(!openReelsCreation)}
        >
          Close
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default observer(ReelsCreationNFAI);
